import { render, staticRenderFns } from "./destiny.vue?vue&type=template&id=8b954b9a&"
import script from "./destiny.vue?vue&type=script&lang=js&"
export * from "./destiny.vue?vue&type=script&lang=js&"
import style0 from "./destiny.vue?vue&type=style&index=0&id=8b954b9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports